import styled from 'styled-components/macro';
import {
  compose,
  space,
  color,
  typography,

  // types
  SpaceProps,
  ColorProps,
  TypographyProps,
} from 'styled-system';

import colors from 'styles/themes/colors';

type HeadingProps = SpaceProps & ColorProps & TypographyProps;

const H1 = styled.h1<HeadingProps>`
  ${compose(space, color, typography)}
`;

H1.defaultProps = {
  my: 2,
  fontWeight: 'bold',
  color: colors.NightBlue,
};

export default H1;
